import { Dispatch } from 'react';
import moment from 'moment';

import ReportService from 'src/services/report.service';
import { IReport, IReportInput } from 'src/interfaces/report';
import { store } from 'src/store';

import { FETCH_REPORT, ReportActionTypes } from './types';

export const fetchReport =
  (values: IReportInput) => async (dispatch: Dispatch<ReportActionTypes>) => {
    let data: IReport | undefined;

    const backupOperation =
      store.getState().reports?.backupOperationReport || undefined;

    const backupOperator =
      store.getState().reports?.backupOperatorReport || undefined;

    const backupOperationGroup =
      store.getState().reports?.backupOperationGroupReport || undefined;

    if (
      !!backupOperator &&
      values.reportType === 'operator' &&
      values.cellId === backupOperator?.cell?.id &&
      moment(backupOperator?.updateAt).isAfter(moment().subtract(10, 'minutes'))
    ) {
      data = backupOperator;
    } else if (
      !!backupOperation &&
      values.reportType === 'operation' &&
      values.cellId === backupOperation?.cell?.id &&
      moment(backupOperation?.updateAt).isAfter(
        moment().subtract(10, 'minutes')
      )
    ) {
      data = backupOperation;
    } else if (
      !!backupOperationGroup &&
      values.reportType === 'operationGroup' &&
      values.cellId === backupOperationGroup?.cell?.id &&
      moment(backupOperationGroup?.updateAt).isAfter(
        moment().subtract(10, 'minutes')
      )
    ) {
      data = backupOperationGroup;
    }

    try {
      if (!data) {
        if (values.reportType === 'efficiency') {
          const response: any = await ReportService.efficiency({
            cellId: values.cellId,
            date: values.date,
          });

          data = {
            reportType: 'efficiency' as const,
            cell: {
              id: response?.cell?.cell_id,
              name: response?.cell?.cell_nome,
            },
            updateAt: moment().toString(),
            data: response.operators,
            averageEfficiency: response.averageEfficiency,
          };
        } else if (values.reportType === 'operationGroup') {
          const response: any = await ReportService.byOperationGroup({
            cellId: values.cellId,
            date: values.date,
          });

          data = {
            reportType: 'operationGroup' as const,
            cell: response?.cell,
            updateAt: moment().toString(),
            data: response.productions,
            averageEfficiency: response?.averageEfficiency,
            totalProduction: response?.totalProduction,
            color: response?.color,
            cellTargetAccumulated: response?.cellTargetAccumulated,
            totalCellOperationsQuantity: response?.totalCellOperationsQuantity,
          };
        } else {
          const response: any = await ReportService.current(values);

          data = {
            reportType: values?.reportType,
            cell: response?.cell,
            updateAt: moment().toString(),
            data: response.productions,
          };
        }
      }

      dispatch({
        type: FETCH_REPORT,
        payload: data,
      });

      return data;
    } catch (err) {
      console.dir(err, 'erro');
      throw err;
    }
  };
